// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox_wrapper__O__3M","checkbox":"Checkbox_checkbox__3YCdG","small":"Checkbox_small__3_Hpm","checked":"Checkbox_checked__2T4vp","dash":"Checkbox_dash__1Mrfi"};